import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, ViewChildren, QueryList, ViewContainerRef, ComponentFactoryResolver } from "@angular/core";
import { Router } from "@angular/router";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ClientesService } from "../../services/clientes.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { VendasService } from "../../services/vendas.service";
import { Utilservice } from "@core/services/util.service";
import * as toastr from 'toastr'

import * as html2pdf from 'html2pdf.js';
import { ParametersExportBalance } from "@modules/clientes/services/clientes.interface";
import { RequestWithFetchStatus } from "@shared/utils/request-with-fetch-status";
import * as moment from "moment";

@Component({
  selector: "app-espelho-pedido",
  templateUrl: "./espelho-pedido.component.html",
  styleUrls: ["./espelho-pedido.component.css"]
})
export class EspelhoPedidoComponent implements OnInit {
  faEdit = faEdit;
  lsClients: any[] = [];
  lsPedidos: any[] = [];
  lsPedidoVenda: any[] = [];

  parameters = {
    IdVendedor: "",
    cnpj: "",
    razaoSocial: "",
    idpedido: ""
  };

  paramsPedido = {
    idpedido: "",
    dtEmissaoPedido: ""
  };

  desc1: any;
  dsCorpoEmail: any;
  showEspelho: boolean = false;
  showFaturamento: boolean = false;
  tableSwit: boolean = true;
  tableThree: boolean = false;
  tableFour: boolean = false;
  corpoEmail: any;
  emailCliente: any;

  count: any;
  avaregePrice: any;
  confirmEmail: any;

  pedidoDetalhe: any = [];
  pedidoDetalhePeditoFaturado: any = [];

  emailSend: boolean = false;
  hasSearch: boolean = false;
  isClienteSelected: boolean = false;
  isRequesting: boolean = false;
  isRequestingPedido: boolean = true;
  hasPedidoSave: boolean = false;
  isSaving: boolean = false;
  sendingEmail: boolean = false;
  isEspelhoPedido: boolean = false;
  isEspelhoFaturamento: boolean = false;

  userLogado;

  lsVetorPed: any = [];
  lsVetor: any = [];
  vencimentoDuplicata: any;
  lsPedDet: any = [];
  lsPedDet1: any = [];
  lsPedDet2: any = [];
  lsPedDet3: any = [];
  lsPedDet4: any = [];
  lsPedDet5: any = [];
  lsPedDet6: any = [];
  baseUrl: string = "";
  quantidadeTotal: any;
  totalGeral: any;

  emailVendedorLogdo = localStorage.getItem("auth_token")

  exportRequest = new RequestWithFetchStatus<any>()

  constructor(
    private clientService: ClientesService,
    private vendaService: VendasService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));

    this.parameters.IdVendedor = this.userLogado.id;
  }

  @ViewChild('closebutton', { static: false }) closebutton;
  @ViewChild('myModal', { static: false }) myModal;

  reset(type) {
    if (type === "all") {
      this.parameters = {
        IdVendedor: this.userLogado.id,
        cnpj: "",
        razaoSocial: "",
        idpedido: ""
      };

      this.lsClients = [];
      this.hasSearch = false;
      this.isClienteSelected = false;
      this.hasPedidoSave = false;
    } else if (type === "first") {
      this.isClienteSelected = false;
    } else if(type === "second"){
      this.isClienteSelected = true;
      this.showEspelho = false;
      this.showFaturamento = false;
      this.tableSwit = true;
    } else if(type == "third"){
      this.isClienteSelected = true;
      this.showEspelho = false;
      this.showFaturamento = false;
      this.tableSwit = true;
    }
     else {
      this.hasPedidoSave = false;
    }
  }

  search() {
    this.hasSearch = true;

    this.isRequesting = true;

    const parameters = {
      ...this.parameters
    }

    this.clientService.getEspelhoPedido(parameters).subscribe(
      data => {
        this.isRequesting = false;

        this.lsClients = data;

        this.paramsPedido.idpedido = this.lsClients[0].pedido;
        this.paramsPedido.dtEmissaoPedido = this.lsClients[0].dtEmissaoPedido;
      },
      error => console.log(error)
    );
  }

  searchFaturamento(){
    
    const paramsPedido = {
      ...this.paramsPedido
    }

    this.lsPedDet = [];
    this.lsPedDet1 = [];
    this.lsPedDet2 = [];
    this.lsPedDet3 = [];
    this.lsPedDet4 = [];
    this.lsPedDet5 = [];
    this.lsPedDet6 = [];

    this.clientService.getReportPedidoConformeFaturamento(paramsPedido).subscribe(
      data => {
        this.lsPedidoVenda = data;

        console.log(this.lsPedidoVenda, "lspedidovenda");

        const leng = this.lsPedidoVenda[0].pedidoDetalhe.length;
        this.avaregePrice = parseFloat(this.lsPedidoVenda[0].pedidoDetalhe[leng-1].precoMedio);
        this.lsPedidoVenda[0].pedidoDetalhe.push({cor: null, dsItemModelo: "Preço Médio Faturado", dtEmisPed: null, idProd: 0, noPed: null, precoMedio: null, precoUnitario: null, qtdPecasFaturadas: null, qtdPecasPedidas: null, sumQtdPedito: null, sumValorTotalComDesconto: null, tamanho: null, valorTotalComDesconto: this.avaregePrice});

        if (this.lsPedidoVenda[0].pcDescDPCM/10){
          this.desc1 = `${this.lsPedidoVenda[0].pcDescVend/10}% + ${this.lsPedidoVenda[0].pcDescDPCM/10}%`;
        } else if(this.lsPedidoVenda[0].pcDescVend){
          this.desc1 = `${this.lsPedidoVenda[0].pcDescVend/10}%`;
        }
        console.log(this.lsPedidoVenda[0].pedidoDetalhe);

        if(this.lsPedidoVenda[0].bdtve1 == "0001-01-01T00:00:00"){
          this.lsPedidoVenda[0].bdtve1 = null;
          this.lsPedidoVenda[0].bdtve2 = null;
          this.lsPedidoVenda[0].bdtve3 = null;
          this.lsPedidoVenda[0].bdtve4 = null;
        }
        else if (this.lsPedidoVenda[0].bdtve2 == "0001-01-01T00:00:00"){
          this.lsPedidoVenda[0].bdtve2 = null;
          this.lsPedidoVenda[0].bdtve3 = null;
          this.lsPedidoVenda[0].bdtve4 = null;
        }
        else if (this.lsPedidoVenda[0].bdtve3 == "0001-01-01T00:00:00"){
          this.lsPedidoVenda[0].bdtve3 = null;
          this.lsPedidoVenda[0].bdtve4 = null;
        }
        if (this.lsPedidoVenda[0].bdtve4 == "0001-01-01T00:00:00"){
          this.lsPedidoVenda[0].bdtve4 = null;
        }

        if(this.lsPedidoVenda[0].qtDiaPrzPgto4 != 0){
          this.vencimentoDuplicata = this.lsPedidoVenda[0].qtDiaPrzPgto1 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto2 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto3 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto4 + " DIAS";
        }
        else if(this.lsPedidoVenda[0].qtDiaPrzPgto3 != 0){
          this.vencimentoDuplicata = this.lsPedidoVenda[0].qtDiaPrzPgto1 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto2 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto3 + " DIAS";
        }
        else if(this.lsPedidoVenda[0].qtDiaPrzPgto2 != 0){
          this.vencimentoDuplicata = this.lsPedidoVenda[0].qtDiaPrzPgto1 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto2 + " DIAS";
        }
        else if(this.lsPedidoVenda[0].qtDiaPrzPgto1 != 0){
          this.vencimentoDuplicata = this.lsPedidoVenda[0].qtDiaPrzPgto1 + " DIAS";
        }

        this.isEspelhoFaturamento = false;

      },
      error => console.log(error)
    );
  }

  searchPedido() {

    const paramsPedido = {
      ...this.paramsPedido
    }

    this.lsPedDet = [];
    this.lsPedDet1 = [];
    this.lsPedDet2 = [];
    this.lsPedDet3 = [];
    this.lsPedDet4 = [];
    this.lsPedDet5 = [];
    this.lsPedDet6 = [];

    this.clientService.getReportPedidoConformeVenda(paramsPedido).subscribe(
      data => {
        this.lsPedidoVenda = data;

        console.log(this.lsPedidoVenda, "lspedidovenda");

        const leng = this.lsPedidoVenda[0].pedidoDetalhe.length;
        this.avaregePrice = parseFloat(this.lsPedidoVenda[0].pedidoDetalhe[leng-1].precoMedio);
        this.lsPedidoVenda[0].pedidoDetalhe.push({cor: null, dsItemModelo: "Preço Médio do Pedido", dtEmisPed: null, idProd: 0, noPed: null, precoMedio: null, precoUnitario: null, qtdPecasFaturadas: null, qtdPecasPedidas: null, sumQtdPedito: null, sumValorTotalComDesconto: null, tamanho: null, valorTotalComDesconto: this.avaregePrice});

        if (this.lsPedidoVenda[0].pcDescDPCM/10){
          this.desc1 = `${this.lsPedidoVenda[0].pcDescVend/10}% + ${this.lsPedidoVenda[0].pcDescDPCM/10}%`;
        } else if(this.lsPedidoVenda[0].pcDescVend){
          this.desc1 = `${this.lsPedidoVenda[0].pcDescVend/10}%`;
        }
        console.log(this.lsPedidoVenda[0].pedidoDetalhe);

        if(this.lsPedidoVenda[0].bdtve1 == "0001-01-01T00:00:00"){
          this.lsPedidoVenda[0].bdtve1 = null;
          this.lsPedidoVenda[0].bdtve2 = null;
          this.lsPedidoVenda[0].bdtve3 = null;
          this.lsPedidoVenda[0].bdtve4 = null;
        }
        else if (this.lsPedidoVenda[0].bdtve2 == "0001-01-01T00:00:00"){
          this.lsPedidoVenda[0].bdtve2 = null;
          this.lsPedidoVenda[0].bdtve3 = null;
          this.lsPedidoVenda[0].bdtve4 = null;
        }
        else if (this.lsPedidoVenda[0].bdtve3 == "0001-01-01T00:00:00"){
          this.lsPedidoVenda[0].bdtve3 = null;
          this.lsPedidoVenda[0].bdtve4 = null;
        }
        if (this.lsPedidoVenda[0].bdtve4 == "0001-01-01T00:00:00"){
          this.lsPedidoVenda[0].bdtve4 = null;
        }

        if(this.lsPedidoVenda[0].qtDiaPrzPgto4 != 0){
          this.vencimentoDuplicata = this.lsPedidoVenda[0].qtDiaPrzPgto1 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto2 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto3 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto4 + " DIAS";
        }
        else if(this.lsPedidoVenda[0].qtDiaPrzPgto3 != 0){
          this.vencimentoDuplicata = this.lsPedidoVenda[0].qtDiaPrzPgto1 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto2 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto3 + " DIAS";
        }
        else if(this.lsPedidoVenda[0].qtDiaPrzPgto2 != 0){
          this.vencimentoDuplicata = this.lsPedidoVenda[0].qtDiaPrzPgto1 + "/" + this.lsPedidoVenda[0].qtDiaPrzPgto2 + " DIAS";
        }
        else if(this.lsPedidoVenda[0].qtDiaPrzPgto1 != 0){
          this.vencimentoDuplicata = this.lsPedidoVenda[0].qtDiaPrzPgto1 + " DIAS";
        }

        this.isEspelhoPedido = false;        

      },
      error => console.log(error)
    );
  }
  
  espelhoShow() {
    this.showEspelho = true;
    this.showFaturamento = false;
    this.isEspelhoPedido = true;
    this.searchPedido();
  }

  faturamentoShow() {
    this.showFaturamento = true;
    this.showEspelho = false;
    this.isEspelhoFaturamento = true;
    this.searchFaturamento();
  }

  sessionTable() {
    this.lsVetorPed = [];
    this.lsVetor = [];
    // console.log(this.lsPedidoVenda[0].pedidoDetalhe.length, 'length sessionTable')
    if(this.lsPedidoVenda[0].pedidoDetalhe.length > 199){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      let l = 0;
      let m = 0;
      let n = 0;
      let o = 0;
      for(let i = 0; i < 14; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 14; i < 51; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 51; i < 88; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
      for(let i = 88; i < 125; i++){
        this.lsPedDet3[l] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        l ++;
      }
      for(let i = 125; i < 162; i++){
        this.lsPedDet4[m] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        m ++;
      }
      for(let i = 162; i < 199; i++){
        this.lsPedDet5[n] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        n ++;
      }
      for(let i = 199; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet6[o] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        o ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 162){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      let l = 0;
      let m = 0;
      let n = 0;
      for(let i = 0; i < 14; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 14; i < 51; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 51; i < 88; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
      for(let i = 88; i < 125; i++){
        this.lsPedDet3[l] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        l ++;
      }
      for(let i = 125; i < 162; i++){
        this.lsPedDet4[m] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        m ++;
      }
      for(let i = 162; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet5[n] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        n ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 125){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      let l = 0;
      let m = 0;
      for(let i = 0; i < 14; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 14; i < 51; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 51; i < 88; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
      for(let i = 88; i < 125; i++){
        this.lsPedDet3[l] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        l ++;
      }
      for(let i = 125; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet4[m] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        m ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 88){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      let l = 0;
      for(let i = 0; i < 14; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 14; i < 51; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 51; i < 88; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
      for(let i = 88; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet3[l] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        l ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 51){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      for(let i = 0; i < 14; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 14; i < 51; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 51; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 14){
      this.tableSwit = false;
      let j = 0;
      for(let i = 0; i < 14; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 14; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
    }
    this.lsVetor.push(this.lsPedDet1, this.lsPedDet, this.lsPedDet2, this.lsPedDet3, this.lsPedDet4, this.lsPedDet5, this.lsPedDet6);
    for(let i = 0; i < this.lsVetor.length; i++){
      if(this.lsVetor[i].length > 0){
        this.lsVetorPed.push(this.lsVetor[i]);
      }
    }
    console.log(this.lsVetorPed, "lsVetorped");
  }

  async downloadPDF() {
    this.sessionTable();
    const config = {
      html2canvas: {
        scale: 1,
        scrollX: 0,
        scrollY: 0,
      },
    };

    const content: Element = document.getElementById('espelho');


    await html2pdf().set(config).from(content).save(`ESPELHO-PEDIDO-${this.lsPedidoVenda[0].noPedido}`);

    this.tableSwit = true;

  }

  sessionTable_FatNew(){
    this.lsVetorPed = [];
    this.lsVetor = [];
    if(this.lsPedidoVenda[0].pedidoDetalhe.length > 195){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      let l = 0;
      let m = 0;
      let n = 0;
      let o = 0;
      for(let i = 0; i < 10; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 10; i < 47; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 47; i < 84; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
      for(let i = 84; i < 121; i++){
        this.lsPedDet3[l] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        l ++;
      }
      for(let i = 121; i < 158; i++){
        this.lsPedDet4[m] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        m ++;
      }
      for(let i = 158; i < 195; i++){
        this.lsPedDet5[n] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        n ++;
      }
      for(let i = 195; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet6[o] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        o ++;
      }
    }
    if(this.lsPedidoVenda[0].pedidoDetalhe.length > 158){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      let l = 0;
      let m = 0;
      let n = 0;
      for(let i = 0; i < 10; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 10; i < 47; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 47; i < 84; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
      for(let i = 84; i < 121; i++){
        this.lsPedDet3[l] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        l ++;
      }
      for(let i = 121; i < 158; i++){
        this.lsPedDet4[m] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        m ++;
      }
      for(let i = 158; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet5[n] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        n ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 121){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      let l = 0;
      let m = 0;
      for(let i = 0; i < 10; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 10; i < 47; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 47; i < 84; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
      for(let i = 84; i < 121; i++){
        this.lsPedDet3[l] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        l ++;
      }
      for(let i = 121; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet4[m] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        m ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 84){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      let l = 0;
      for(let i = 0; i < 10; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 10; i < 47; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 47; i < 84; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
      for(let i = 84; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet3[l] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        l ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 47){
      this.tableSwit = false;
      let j = 0;
      let k = 0;
      for(let i = 0; i < 10; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 10; i < 47; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
      for(let i = 47; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet2[k] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        k ++;
      }
    }
    else if(this.lsPedidoVenda[0].pedidoDetalhe.length > 10){
      this.tableSwit = false;
      let j = 0;
      for(let i = 0; i < 10; i++){
        this.lsPedDet1[i] = this.lsPedidoVenda[0].pedidoDetalhe[i];
      }
      for(let i = 10; i < this.lsPedidoVenda[0].pedidoDetalhe.length; i++){
        this.lsPedDet[j] = this.lsPedidoVenda[0].pedidoDetalhe[i];
        j ++;
      }
    }
    this.lsVetor.push(this.lsPedDet1, this.lsPedDet, this.lsPedDet2, this.lsPedDet3, this.lsPedDet4, this.lsPedDet5, this.lsPedDet6);
    for(let i = 0; i < this.lsVetor.length; i++){
      if(this.lsVetor[i].length > 0){
        this.lsVetorPed.push(this.lsVetor[i]);
      }
    }
    console.log(this.lsVetorPed, "lsVetorped");
  }

  async downloadPDF_Fat() {
    this.sessionTable_FatNew();
    const config = {
      html2canvas: {
        scale: 1,
        scrollX: 0,
        scrollY: 0,
      },
    };

    const content: Element = document.getElementById('faturamento');

    await html2pdf()
      .set(config)
      .from(content)
      .save(`ESPELHO-FATURAMENTO-${this.lsPedidoVenda[0].noPedido}`);

    this.tableSwit = true;

  }

  emailTeste(){
    this.emailCliente = this.lsPedidoVenda[0].email;
    this.corpoEmail = "";
    this.myModal.nativeElement.click();
  }

  async sendEmail(){
    if(this.showFaturamento){
      if(this.validateEmail(this.emailCliente)){
        this.sendingEmail = true;
        this.sessionTable_FatNew();
        const config = {
          html2canvas: {
            scale: 1,
            scrollX: 0,
            scrollY: 0,
          },
        };
    
        const content: Element = document.getElementById('faturamento');
    
        await html2pdf()
          .set(config)
          .from(content)
          .toPdf()
          .outputPdf('datauristring')
          .then(value => {
            localStorage.setItem('FaturamentoPdf', value);
          });

        let emailVend = localStorage.getItem("auth_token");

        let paramsEmail = {
          email: this.emailCliente,
          no_ped: this.lsPedidoVenda[0].noPedido,
          tipoRelatorio: "Espelho do Faturamento",
          dsCorpoEmail: this.corpoEmail,
          emailVendedor: emailVend,
          pdfBase64: localStorage.getItem('FaturamentoPdf').replace('data:application/pdf;base64,', '')
        }

        if(this.corpoEmail == ""){
          this.tableSwit = true;
          this.sendingEmail = false;
          toastr.error("Digite o corpo do email.");
        } else {
          this.clientService.convertBase64ToPdfAndSendReportEmail(paramsEmail).subscribe(
            data => {
              this.confirmEmail = data;
              paramsEmail = {
                email: "",
                no_ped: "",
                tipoRelatorio: "",
                dsCorpoEmail: "",
                emailVendedor: "",
                pdfBase64: ""
              }
              this.corpoEmail = "";
              this.sendingEmail = false;
              this.tableSwit = true;
              this.closebutton.nativeElement.click();
              toastr.success("Email enviado com sucesso");
            },
            error => {
              toastr.error("Error ao enviar o email.");
            }
          );
        }

      } else if (!this.validateEmail(this.emailCliente)) {
        this.emailCliente = this.lsPedidoVenda[0].email;
        this.corpoEmail = "";
        toastr.error("Email inválido, por favor certifique se o email esta correto.");
      }
      localStorage.removeItem('FaturamentoPdf');
    }
    if(this.showEspelho){
      if(this.validateEmail(this.emailCliente)){
        this.sendingEmail = true;
        this.sessionTable();
        const config = {
          html2canvas: {
            scale: 1,
            scrollX: 0,
            scrollY: 0,
          },
        };

        const content: Element = document.getElementById('espelho');
    
        await html2pdf()
          .set(config)
          .from(content)
          .toPdf()
          .outputPdf('datauristring')
          .then(function(value){
            localStorage.setItem('EspelhoPdf', value);
          });

        let emailVend = localStorage.getItem("auth_token");
        
        let paramsEmail = {
          email: this.emailCliente,
          no_ped: this.lsPedidoVenda[0].noPedido,
          tipoRelatorio: "Espelho do Pedido",
          dsCorpoEmail: this.corpoEmail,
          emailVendedor: emailVend,
          pdfBase64: localStorage.getItem('EspelhoPdf').replace('data:application/pdf;base64,', '')
        }

        if(this.corpoEmail == ""){
          this.tableSwit = true;
          this.sendingEmail = false;
          toastr.error("Digite o corpo do email.");
        } else {
          this.clientService.convertBase64ToPdfAndSendReportEmail(paramsEmail).subscribe(
            data => {
              this.confirmEmail = data;
              paramsEmail = {
                email: "",
                no_ped: "",
                tipoRelatorio: "",
                dsCorpoEmail: "",
                emailVendedor: "",
                pdfBase64: ""
              }
              this.corpoEmail = "";
              this.sendingEmail = false;
              this.tableSwit = true;
              this.closebutton.nativeElement.click();
              toastr.success("Email enviado com sucesso");
            },
            error => {
              toastr.error("Error ao enviar o email.");
            }
          );
        }
      }
      else if (!this.validateEmail(this.emailCliente)) {
        this.emailCliente = this.lsPedidoVenda[0].email;
        this.corpoEmail = "";
        toastr.error("Email inválido, por favor certifique se o email esta correto.");
      }
      localStorage.removeItem('EspelhoPdf');
    }
  }

  selectClient(client) {
    //console.log(client ,'cliente obj');
    this.isClienteSelected = true;

    this.isRequestingPedido = true;

    this.paramsPedido.idpedido = client.pedido;
    this.paramsPedido.dtEmissaoPedido = client.dtEmissaoPedido;

    //this.clientService.getConsultaPedido({ idpedido: client.pedido }).subscribe(
    this.clientService.getConsultaPedidoComDataEmissaoPedido({ idpedido: client.pedido, dtEmissaoPedido: client.dtEmissaoPedido  }).subscribe(
      data => {
        this.isRequestingPedido = false;

        this.lsPedidos = data;

        if(this.lsPedidos[0].numero == null){
          this.lsPedidos[0].numero = '';
        }

        this.pedidoDetalhe = data.length > 0 ? data[0].pedidoDetalhe : [];

        this.pedidoDetalhePeditoFaturado = this.pedidoDetalhe.filter(
          value => value.qtPecasPed > value.qtPecasFat
        );
      },
      error => {
        alert("Error ao carregar pedido.");

        this.isClienteSelected = false;

        this.isRequestingPedido = false;
      }
    );
  }

  salvarPedido() {
    this.hasPedidoSave = true;
  }

  gerarSaldo() {
    window.open(
      `${this.clientService.baseUrl}/carteiraPedido/NovoPedido?idpedido=${this.lsPedidos[0].noPed}&dtEmissaoPedido=${this.lsClients[0].dtEmissaoPedido}`,
      "_blank"
    );

    this.reset("all");
  }

  somatorio(){
    this.lsClients.length
    let i;
    this.count = 0;
    for(i = 0; i < this.lsClients.length; i++){
      this.count = this.count + (this.lsClients[i].qtdPecas - this.lsClients[i].qtdPecasFaturadas);
    }
  }

  formatCnpj(v) {
    if (v) return Utilservice.formatCnpj(v);
  }

  formatDate(date) {
    if (date) {
      if (date.indexOf("T") >= 0) {
        const dateSplit = date.split("T");

        date = dateSplit[0];

        date = date
          .split("-")
          .reverse()
          .join("/");
      }

      return Utilservice.formatDate(date);
    }
  }

  formatCep(cep) {
    if (cep) return Utilservice.formatCep(cep);
  }

  formatMoneyValue(value){
    return Utilservice.formatMoney(value)
  }

  formatQuantity(value) {
    return Utilservice.formatQuantity(value)
  }

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  handleExport(){
    const paramsPedido = {
      ...this.paramsPedido
    }

    let params: ParametersExportBalance = {
      idPedido: paramsPedido.idpedido,
      dtEmissaoPedido: paramsPedido.dtEmissaoPedido
    };

    if(!paramsPedido) return;

    this.exportBalance(params);
  }

  private exportBalance(params: ParametersExportBalance){

    var count = 0;
    this.exportRequest.get(
      this.clientService.exportBalance(params)
    ).subscribe(
      response => {
        count++;
        if(count > 1)return;
        Utilservice.exportToFile(
          response.blob(),
          `exportacao-carteira-clientes setor-${moment().format('DD/MM/YYYY HH:mm:ss')}.pdf`, 'application/pdf'
        )
      }
    )
  }
}
